import { Spin } from 'antd';

export default function Loading() {
	return (
		<div className='loading-wrapper'>
			<Spin size='large' />
		</div>
	)
}
